var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _linearGradient5, _path7, _linearGradient6, _path8, _linearGradient7, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: -2840.169,
    y1: -250.074,
    x2: -2839.169,
    y2: -250.074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M73.72 98.124h86.971v28.61H36.762v-22.993M48.663 64.987c5.795-15.935 14.691-19.283 14.691-19.283h5.1M43.844 93.799c.209-7.429.977-13.743 2.096-19.102M91.74 45.704H131.759M132.064 45.768s19.45 7.321 19.563 51.846M98.514 19.823h32.799v15.549H98.514zM107.756 35.372v10.335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.838 35.372v10.335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.907 20.05h21.954v37.814H68.907zM64.026 57.864h31.717"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: 74.587,
    y1: 29.407,
    x2: 85.095,
    y2: 29.407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M75.837 29.407h8.008"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: 74.587,
    y1: 38.99,
    x2: 85.095,
    y2: 38.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M75.837 38.99h8.008"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: 74.587,
    y1: 48.432,
    x2: 85.095,
    y2: 48.432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M75.837 48.432h8.008"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: 26.542,
    y1: 98.764,
    x2: 74.463,
    y2: 98.764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M27.792 94.437v8.838h30.324v10.679L73.213 98.12 57.748 83.574v10.863z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: 11.021,
    y1: 69.858,
    x2: 58.942,
    y2: 69.858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M57.692 74.184v-8.837H27.368V54.668L12.271 70.502l15.465 14.545V74.184z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc",
    gradientUnits: "userSpaceOnUse",
    x1: 92.962,
    y1: 112.297,
    x2: 105.404,
    y2: 112.297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.183,
    cy: 112.297,
    r: 4.971,
    fill: "none",
    stroke: "url(#SVGID_6_bc2ee475967cd021eb997c705ad1a9575499cce031f9c16f94ae6368a3228afc)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashReceipts);
export default __webpack_public_path__ + "static/media/cashReceipts.a3c047ed6b514ca0de5eee80d698e029.svg";
export { ForwardRef as ReactComponent };